import "../../styles/blocks/shopify-themes/shopify-themes-header.scss";

import React, { useEffect } from "react"
import PropTypes from "prop-types"

const linkRel = "noreferrer"

const DesktopLogoIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    className="shopify-themes-header__logo-icon shopify-themes-header__logo-icon--desktop header__logo-icon header__logo-icon--desktop"
    width="24"
    height="30"
    viewBox="0 0 24 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0694 0.972934C11.2653 0.972934 11.3633 1.08084 11.5592 1.18875C10.3837 1.72828 9.20815 3.13108 8.6204 6.15248L6.4653 6.79992C7.15101 4.64178 8.52244 0.972934 11.0694 0.972934ZM12.1469 2.05201C12.3428 2.69945 12.5388 3.4548 12.5388 4.64178C12.5388 4.74969 12.5388 4.74969 12.5388 4.85759L9.69795 5.72085C10.2857 3.4548 11.2653 2.48363 12.1469 2.05201ZM14.6939 3.99434L13.4204 4.42596C13.4204 4.31806 13.4204 4.21015 13.4204 4.10224C13.4204 3.13108 13.3224 2.37573 13.1265 1.72828C13.8122 1.9441 14.4 2.91526 14.6939 3.99434ZM21.0612 5.72085C21.0612 5.61294 20.9632 5.50504 20.8653 5.50504C20.6694 5.50504 18.6122 5.28922 18.6122 5.28922C18.6122 5.28922 17.1428 3.67061 16.9469 3.56271C16.751 3.34689 16.4571 3.4548 16.3592 3.4548C16.3592 3.4548 16.0653 3.56271 15.5755 3.77852C15.0857 2.26782 14.2041 0.865027 12.7347 0.865027H12.6367C12.2449 0.217583 11.6571 0.0017689 11.1673 0.0017689C7.64081 -0.106138 5.9755 4.74969 5.38775 7.23155C4.60408 7.44737 3.8204 7.77109 2.93877 8.09481C2.1551 8.31063 2.1551 8.41853 2.05714 9.17388C1.95918 9.71342 0 26.7628 0 26.7628L15.5755 30L24 27.9497C24 27.9497 21.0612 5.93667 21.0612 5.72085Z"
      fill="#212326"
    />
    <path
      d="M20.7497 5.08537C20.6512 5.08537 18.5828 4.86585 18.5828 4.86585C18.5828 4.86585 17.1053 3.21951 16.9084 3.10976C16.8099 3 16.8099 3 16.7114 3L15.5294 30L24 27.9146C24 27.9146 21.0452 5.52439 21.0452 5.30488C21.0452 5.19512 20.8482 5.08537 20.7497 5.08537Z"
      fill="#212326"
    />
    <path
      d="M12.7059 10.9361L11.704 14.3132C11.704 14.3132 10.8842 13.7856 9.79127 13.7856C8.24288 13.7856 8.1518 14.8409 8.1518 15.1575C8.1518 16.635 11.6129 17.2682 11.6129 20.8564C11.6129 23.7059 10.0645 25.5 7.96964 25.5C5.51043 25.5 4.23529 23.7059 4.23529 23.7059L4.87286 21.173C4.87286 21.173 6.148 22.4395 7.24098 22.4395C7.96964 22.4395 8.24288 21.8063 8.24288 21.2786C8.24288 19.2734 5.41935 19.1679 5.41935 15.8963C5.41935 13.1523 7.1499 10.514 10.5199 10.514C12.0683 10.4084 12.7059 10.9361 12.7059 10.9361Z"
      fill="#FFFFFE"
    />
  </svg>
)

const MobileLogoIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    className="shopify-themes-header__logo-icon shopify-themes-header__logo-icon--mobile header__logo-icon header__logo-icon--mobile"
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.22448 0.810778C9.38775 0.810778 9.46938 0.900701 9.63264 0.990624C8.65305 1.44024 7.67346 2.60923 7.18367 5.12707L5.38775 5.6666C5.95918 3.86815 7.10203 0.810778 9.22448 0.810778ZM10.1224 1.71001C10.2857 2.24954 10.449 2.879 10.449 3.86815C10.449 3.95807 10.449 3.95807 10.449 4.048L8.08162 4.76738C8.57142 2.879 9.38775 2.0697 10.1224 1.71001ZM12.2449 3.32861L11.1837 3.6883C11.1837 3.59838 11.1837 3.50846 11.1837 3.41854C11.1837 2.60923 11.102 1.97977 10.9388 1.44024C11.5102 1.62008 12 2.42939 12.2449 3.32861ZM17.551 4.76738C17.551 4.67745 17.4694 4.58753 17.3877 4.58753C17.2245 4.58753 15.5102 4.40769 15.5102 4.40769C15.5102 4.40769 14.2857 3.05885 14.1224 2.96892C13.9592 2.78908 13.7143 2.879 13.6326 2.879C13.6326 2.879 13.3877 2.96892 12.9796 3.14877C12.5714 1.88985 11.8367 0.720856 10.6122 0.720856H10.5306C10.2041 0.181319 9.71428 0.00147408 9.30611 0.00147408C6.36734 -0.0884486 4.97959 3.95807 4.48979 6.02629C3.83673 6.20614 3.18367 6.47591 2.44898 6.74568C1.79592 6.92552 1.79592 7.01544 1.71428 7.6449C1.63265 8.09452 0 22.3023 0 22.3023L12.9796 25L20 23.2915C20 23.2915 17.551 4.94722 17.551 4.76738Z"
      fill="#212326"
    />
    <path
      d="M17.2914 4.2378C17.2093 4.2378 15.4857 4.05488 15.4857 4.05488C15.4857 4.05488 14.2545 2.68293 14.0903 2.59146C14.0082 2.5 14.0082 2.5 13.9261 2.5L12.9412 25L20 23.2622C20 23.2622 17.5376 4.60366 17.5376 4.42073C17.5376 4.32927 17.3735 4.2378 17.2914 4.2378Z"
      fill="#212326"
    />
    <path
      d="M10.5883 9.11341L9.75336 11.9277C9.75336 11.9277 9.07025 11.488 8.15943 11.488C6.86911 11.488 6.79321 12.3674 6.79321 12.6313C6.79321 13.8625 9.67746 14.3902 9.67746 17.3804C9.67746 19.7549 8.38714 21.25 6.6414 21.25C4.59207 21.25 3.52945 19.7549 3.52945 19.7549L4.06076 17.6442C4.06076 17.6442 5.12338 18.6996 6.03419 18.6996C6.6414 18.6996 6.86911 18.1719 6.86911 17.7321C6.86911 16.0612 4.51617 15.9732 4.51617 13.2469C4.51617 10.9603 5.95829 8.76163 8.76664 8.76163C10.057 8.67368 10.5883 9.11341 10.5883 9.11341Z"
      fill="#FFFFFE"
    />
  </svg>
)

const ShopifyThemesHeader = ({ logo }) => {
  const target = logo.target || "_blank"

  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined
    }

    document.body.classList.add("shopify-themes-page-active")

    return () => {
      document.body.classList.remove("shopify-themes-page-active")
    }
  }, [])

  return (
    <section className="shopify-themes-header header js-header">
      <div className="container shopify-themes-header__container header__container">
        <a
          className="shopify-themes-header__logo header__logo"
          href={logo.href}
          target={target}
          rel={target === "_blank" ? linkRel : undefined}
        >
          <DesktopLogoIcon />
          <MobileLogoIcon />

          <span>
            {logo.text} <i>{logo.accentText}</i>
          </span>
        </a>
      </div>
    </section>
  )
}

ShopifyThemesHeader.propTypes = {
  logo: PropTypes.shape({
    href: PropTypes.string.isRequired,
    target: PropTypes.string,
    text: PropTypes.string.isRequired,
    accentText: PropTypes.string.isRequired,
  }).isRequired,
}

export default ShopifyThemesHeader
